import { LocalePicker } from '../components/LocalePicker';

export default LocalePicker;
